function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { createContext, useContext, useEffect, useState } from "react";
export var TranslationsContext = /*#__PURE__*/ createContext({
    translations: {},
    setTranslations: function() {}
});
export function TranslationsProvider(param) {
    var children = param.children, defaultTranslations = param.defaultTranslations;
    var _useState = _sliced_to_array(useState(defaultTranslations || {}), 2), translations = _useState[0], setTranslations = _useState[1];
    return /*#__PURE__*/ React.createElement(TranslationsContext.Provider, {
        value: {
            translations: translations,
            setTranslations: setTranslations
        }
    }, children);
}
function deepCompare(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
}
export function useTranslations(newTranslations) {
    var _useContext = useContext(TranslationsContext), setTranslations = _useContext.setTranslations, translations = _useContext.translations;
    useEffect(function() {
        if (newTranslations && !deepCompare(translations, newTranslations)) {
            setTranslations(newTranslations);
        }
    }, [
        setTranslations,
        newTranslations,
        translations
    ]);
    return translations;
}
export var translations = {
    en: {
        OKhRC6: "Share",
        "+hhOtL": "Share this question",
        lbr3Lq: "Copy link",
        easrV8: "Other question",
        "un5xW/": "Let's speak to each other, not about each other!",
        oRM8fC: "An inclusive society needs people who are prepared to meet each other openly and without prejudice in everyday life. People who stand up against discrimination. People who ask questions and listen rather than judge. Because only by asking questions can we learn about new perspectives. The question generator from the Swiss Church Aid HEKS/EPER organisation makes it easy to start a conversation with over 100 interesting, philosophical, sometimes funny and provocative questions about living together in Switzerland.\n\nGive it a try!",
        "1eP3ff": "Find out more about the campaign (in German and French only):",
        "wRXzP+": "Wann f\xfchlst du dich als Teil der Schweiz?",
        j01SfB: "https://www.heks.ch/inklusion",
        viCfxx: "Would you like to be kept up to date on HEKS issues? Then subscribe to our newsletter in German or French.",
        uLm9eK: "Subscribe",
        d1vipv: "https://www.heks.ch/heks-newsletter",
        ztOMFD: "https://www.heks.ch",
        mgpT34: "Show me a question",
        CCqzim: "https://en.heks.ch/publishing-details",
        xYJkOZ: "Imprint",
        UOugTE: "https://en.heks.ch/privacy-policy",
        RVOcOM: "Privacy Statement",
        xubukL: "A campaign by",
        vvxjpm: "https://en.heks.ch/",
        aMEa3N: "en.heks.ch",
        hcXlt0: "https://discuter-ensemble.eper.ch/",
        ERzGwK: "G\xe9n\xe9rateur de questions en fran\xe7ais",
        PjRbR1: "https://miteinander-reden.heks.ch/",
        "/HzeKf": "Fragengenerator auf Deutsch",
        DAic9k: "Inclusion is in everyone's interest - and we can all contribute to a more inclusive Switzerland."
    },
    de: {
        OKhRC6: "Teilen",
        "+hhOtL": "Diese Frage teilen",
        lbr3Lq: "Link kopieren",
        easrV8: "andere Frage",
        "un5xW/": "Reden wir miteinander statt \xfcbereinander!",
        oRM8fC: "F\xfcr eine inklusive Gesellschaft braucht es Menschen, die bereit sind, einander im Alltag offen und vorurteilsfrei zu begegnen. Menschen, die gegen Diskriminierung einstehen. Menschen, die fragen und zuh\xf6ren, statt zu verurteilen. Denn nur wer Fragen stellt, lernt neue Perspektiven kennen. Der Fragen-Generator von HEKS, dem Hilfswerk der Evangelisch-reformierten Kirche Schweiz, macht es dir mit \xfcber 100 interessanten, philosophischen, manchmal auch witzigen und provokativen Fragen zum Zusammenleben in der Schweiz leicht, den Gespr\xe4chseinstieg zu finden.\n\nProbiere es aus!",
        "1eP3ff": "Weitere Informationen zu unserer Kampagne findest Du hier:",
        "wRXzP+": "Reden wir miteinander statt \xfcbereinander!",
        j01SfB: "https://www.heks.ch/inklusion",
        viCfxx: "M\xf6chtest weiterhin \xfcber Themen von HEKS informiert werden? Dann abonniere unseren Newsletter.",
        uLm9eK: "Abonnieren",
        d1vipv: "https://www.heks.ch/heks-newsletter",
        ztOMFD: "https://www.heks.ch",
        mgpT34: "Zeig mir eine Frage",
        CCqzim: "https://www.heks.ch/impressum",
        xYJkOZ: "Impressum",
        UOugTE: "https://www.heks.ch/datenschutz",
        RVOcOM: "Datenschutz",
        xubukL: "Eine Kampagne von",
        vvxjpm: "https://www.heks.ch/",
        aMEa3N: "heks.ch",
        hcXlt0: "https://discuter-ensemble.eper.ch/",
        ERzGwK: "G\xe9n\xe9rateur de questions en fran\xe7ais",
        PjRbR1: "https://speak-together.heks.ch/",
        "/HzeKf": "Question generator in English",
        DAic9k: "Inklusion ist im Interesse von allen – und wir alle k\xf6nnen zu einer inklusiveren Schweiz beitragen."
    },
    fr: {
        OKhRC6: "Partager",
        "+hhOtL": "Partager cette question",
        lbr3Lq: "Copy link",
        easrV8: "Autre question",
        "un5xW/": "D\xe9passons nos a priori et discutons ensemble!",
        oRM8fC: "Pour une soci\xe9t\xe9 inclusive, il faut des personnes qui sont pr\xeates \xe0 aller \xe0 la rencontre de l’autre en faisant preuve d’ouverture et en se lib\xe9rant de leurs pr\xe9jug\xe9s. Des personnes qui s’engagent contre la discrimination, qui posent des questions et \xe9coutent au lieu de juger. Car ce n’est qu’en posant des questions que nous pouvons d\xe9couvrir d’autres points de vue. Le g\xe9n\xe9rateur digital de questions al\xe9atoires de l’Entraide Protestante Suisse (EPER) vous aide \xe0 lancer la discussion gr\xe2ce \xe0 ses 100 questions int\xe9ressantes, philosophiques, voire parfois dr\xf4les et provocantes sur le vivre-ensemble en Suisse.\n\nTestez-le !",
        "1eP3ff": "Vous trouverez plus d’informations sur notre campagne ici :",
        "wRXzP+": "D\xe9passons nos a priori, discutons ensemble!",
        j01SfB: "https://www.eper.ch/inclusion",
        viCfxx: "Souhaitez-vous continuer \xe0 recevoir des informations sur les th\xe8mes de l’EPER ? Dans ce cas, abonnez-vous \xe0 notre newsletter.",
        uLm9eK: "S’abonner",
        d1vipv: "https://www.eper.ch/newsletter-eper",
        ztOMFD: "https://www.heks.ch",
        mgpT34: "Montrez-moi une question",
        CCqzim: "https://www.eper.ch/mentions-legales",
        xYJkOZ: "Mentions l\xe9gales",
        UOugTE: "https://www.eper.ch/protection-des-donnees",
        RVOcOM: "Protection des donn\xe9es",
        xubukL: "Une campagne de",
        vvxjpm: "https://www.eper.ch/",
        aMEa3N: "eper.ch",
        hcXlt0: "https://miteinander-reden.heks.ch/",
        ERzGwK: "Fragengenerator auf Deutsch",
        PjRbR1: "https://speak-together.heks.ch/",
        "/HzeKf": "Question generator in English",
        DAic9k: "L’inclusion est dans l’int\xe9r\xeat de tou\xb7te\xb7s, et chacun\xb7e de nous peut contribuer \xe0 une Suisse plus inclusive."
    }
};
